<app-ginop-header [small]="true" [image]="image"></app-ginop-header>
<section class="ginop-registration">
  <div *ngIf="pageType === EXHIBITOR && isExhibitorActive" class="container">
    <form [formGroup]="ginopForm" (ngSubmit)="onGinopFormSubmit()">
      <h1 class="ginop-registration-title">Regisztráció</h1>
      <div class="ginop-registration-label">Kérjük töltse ki a jelentkezési lapot</div>

      <div class="ginop-registration-form">
        <div class="input-row ginop-input col-12">
          <mat-form-field corporateFormControlErrorContainer>
            <mat-label>Cégnév *</mat-label>
            <input
              matInput
              type="text"
              formControlName="companyName"
              [errors]="{
                required: 'Ez a mező kötelező!',
                minlength: 'Minimum 5 karakter!',
                maxlength: 'Maximum 100 karakter!'
              }"
            />
          </mat-form-field>
        </div>
        <div class="input-row ginop-input col-12">
          <mat-form-field corporateFormControlErrorContainer>
            <mat-label>Cím/Székhely *</mat-label>
            <input
              matInput
              type="text"
              formControlName="address"
              [errors]="{
                required: 'Ez a mező kötelező!',
                minlength: 'Minimum 5 karakter!',
                maxlength: 'Maximum 100 karakter!'
              }"
            />
          </mat-form-field>
        </div>
        <div class="input-row ginop-input col-12 col-md-6">
          <mat-form-field corporateFormControlErrorContainer>
            <mat-label>Adószám *</mat-label>
            <input
              matInput
              type="text"
              formControlName="vat"
              [errors]="{
                required: 'Ez a mező kötelező!',
                minlength: 'Minimum 5 karakter!',
                maxlength: 'Maximum 100 karakter!'
              }"
            />
          </mat-form-field>
        </div>
        <div class="input-row ginop-input col-12 col-md-6">
          <mat-form-field corporateFormControlErrorContainer>
            <mat-label>Cégjegyzékszám vagy nyilvántartási szám *</mat-label>
            <input
              matInput
              type="text"
              formControlName="registryNumber"
              [errors]="{
                required: 'Ez a mező kötelező!',
                minlength: 'Minimum 5 karakter!',
                maxlength: 'Maximum 100 karakter!'
              }"
            />
          </mat-form-field>
        </div>
        <div class="input-row ginop-input col-12">
          <mat-form-field corporateFormControlErrorContainer>
            <mat-label>Képviselő *</mat-label>
            <input
              matInput
              type="text"
              formControlName="representative"
              [errors]="{
                required: 'Ez a mező kötelező!',
                minlength: 'Minimum 5 karakter!',
                maxlength: 'Maximum 100 karakter!'
              }"
            />
          </mat-form-field>
        </div>
        <div class="input-row ginop-input col-12">
          <mat-form-field corporateFormControlErrorContainer>
            <mat-label>Kontaktszemély neve (aki részt vesz a rendezvényen) *</mat-label>
            <input
              matInput
              type="text"
              formControlName="contactPerson"
              [errors]="{
                required: 'Ez a mező kötelező!',
                minlength: 'Minimum 5 karakter!',
                maxlength: 'Maximum 100 karakter!'
              }"
            />
          </mat-form-field>
        </div>
        <div class="input-row ginop-input col-12">
          <mat-form-field corporateFormControlErrorContainer>
            <mat-label>Beosztás *</mat-label>
            <input
              matInput
              type="text"
              formControlName="position"
              [errors]="{
                required: 'Ez a mező kötelező!',
                minlength: 'Minimum 2 karakter!',
                maxlength: 'Maximum 100 karakter!'
              }"
            />
          </mat-form-field>
        </div>
        <div class="input-row ginop-input col-4 col-md-2">
          <mat-form-field corporateFormControlErrorContainer>
            <mat-label>Előhívó szám *</mat-label>
            <input
              matInput
              type="text"
              formControlName="countryCode"
              minlength="3"
              maxlength="4"
              (keyup)="updateCountryCode()"
              [errors]="{
                required: 'Ez a mező kötelező!',
                minlength: 'Minimum 3 karakter!',
                maxlength: 'Maximum 4 karakter!'
              }"
            />
          </mat-form-field>
        </div>
        <div class="input-row ginop-input col-8 col-md-4">
          <mat-form-field corporateFormControlErrorContainer>
            <mat-label>Telefonszám *</mat-label>
            <input
              matInput
              type="text"
              formControlName="phoneNumber"
              [errors]="{
                required: 'Ez a mező kötelező!',
                minlength: 'Minimum 5 karakter!',
                maxlength: 'Maximum 100 karakter!'
              }"
            />
          </mat-form-field>
        </div>
        <div class="input-row ginop-input col-12 col-md-6">
          <mat-form-field corporateFormControlErrorContainer>
            <mat-label>Email *</mat-label>
            <input
              matInput
              type="text"
              formControlName="email"
              [errors]="{
                email: 'Nem helyes email formátum!',
                required: 'Ez a mező kötelező!',
                minlength: 'Minimum 5 karakter!',
                maxlength: 'Maximum 100 karakter!'
              }"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="ginop-registration-text">
        <p>
          A jelentkezési lap kitöltésével hozzájárulok, hogy a Magyar Turisztikai Ügynökség Zrt. a jelentkezési lapon általam megadott
          személyes adataimat, illetőleg cég adatokat kezelje és tárolja, továbbá a cégadatokat a Magyar Turisztikai Ügynökség Zrt és a
          fenti kiállításon résztvevő többi szervezet számára megismerhetővé tegye.
          <br />
          A * csillaggal jelölt mezők kitöltése kötelező.
        </p>
      </div>

      <div class="ginop-checkbox" corporateFormControlErrorContainer>
        <input id="accept-check-exhibitor" type="checkbox" formControlName="accept" [errors]="{ required: 'Ez a mező kötelező!' }" />
        <label for="accept-check-exhibitor">
          <span>
            Elfogadom az
            <a *ngIf="exhibitorDocument" [href]="exhibitorDocument.path" target="_blank">Adatkezelési tájékoztatót</a>
            *
          </span>
        </label>
      </div>

      <div class="ginop-form-accept">
        <button class="button button-primary" [appBackgroundColor]="'red'">Küldés</button>
      </div>
    </form>
    <div class="thank-you-popup" [class.show]="formSent">
      <div class="popup-background">
        <i class="icon icon-mail-big"></i>
        <div class="thank-you">Köszönjük az érdeklődését, jelentkezését rögzítettük!</div>
      </div>
    </div>
  </div>

  <div *ngIf="pageType === EXHIBITOR && !isExhibitorActive" class="container">
    <h2 class="ginop-registration-title">{{ 'label.gino-exhibitor-registration-closed' | translate }}</h2>
  </div>

  <div *ngIf="pageType === PARTICIPANT && isParticipantActive" class="container">
    <form [formGroup]="ginopForm" (ngSubmit)="onGinopFormSubmit()">
      <h1 class="ginop-registration-title">Registration Form</h1>
      <div class="ginop-registration-label">Please fill in the registration form</div>

      <div class="ginop-registration-form">
        <div class="input-row ginop-input col-12 col-md-6">
          <mat-form-field corporateFormControlErrorContainer>
            <mat-label>
              First name
              <ng-container *ngIf="participantFormFirstName"> / {{ participantFormFirstName }}</ng-container>
              *
            </mat-label>
            <input
              matInput
              type="text"
              formControlName="firstName"
              [errors]="{
                required: 'This is required!',
                minlength: 'Minimum 2 character!',
                maxlength: 'Maximum 100 character!'
              }"
            />
          </mat-form-field>
        </div>
        <div class="input-row ginop-input col-12 col-md-6">
          <mat-form-field corporateFormControlErrorContainer>
            <mat-label>
              Last name
              <ng-container *ngIf="participantFormLastName"> / {{ participantFormLastName }}</ng-container>
              *
            </mat-label>
            <input
              matInput
              type="text"
              formControlName="lastName"
              [errors]="{
                required: 'This is required!',
                minlength: 'Minimum 2 character!',
                maxlength: 'Maximum 100 character!'
              }"
            />
          </mat-form-field>
        </div>
        <div class="input-row ginop-input col-12 col-md-6">
          <mat-form-field corporateFormControlErrorContainer>
            <mat-label>
              Company Name
              <ng-container *ngIf="participantFormCompanyName"> / {{ participantFormCompanyName }}</ng-container>
              *
            </mat-label>
            <input
              matInput
              type="text"
              formControlName="companyName"
              [errors]="{
                required: 'This is required!',
                minlength: 'Minimum 5 character!',
                maxlength: 'Maximum 100 character!'
              }"
            />
          </mat-form-field>
        </div>
        <div class="input-row ginop-input col-12 col-md-6">
          <mat-form-field corporateFormControlErrorContainer>
            <mat-label>
              Position
              <ng-container *ngIf="participantFormPosition"> / {{ participantFormPosition }}</ng-container>
              *
            </mat-label>
            <input
              matInput
              type="text"
              formControlName="position"
              [errors]="{
                required: 'This is required!',
                minlength: 'Minimum 2 character!',
                maxlength: 'Maximum 100 character!'
              }"
            />
          </mat-form-field>
        </div>
        <div class="input-row ginop-input col-12">
          <mat-form-field corporateFormControlErrorContainer>
            <mat-label>Email *</mat-label>
            <input
              matInput
              type="text"
              formControlName="email"
              [errors]="{
                email: 'Please enter a valid email format!',
                required: 'This is required!',
                minlength: 'Minimum 5 character!',
                maxlength: 'Maximum 100 character!'
              }"
            />
          </mat-form-field>
        </div>
      </div>

      <div class="ginop-registration-text">
        <p>
          By submitting the application, you expressly consent to the data processing purpose necessary to process the application in
          accordance with the data management information for applicants.
          <ng-container *ngIf="participantFormText1"><br />{{ participantFormText1 }}</ng-container>
          <br />
          All fields marked with an * are required.
          <ng-container *ngIf="participantFormText2">/ {{ participantFormText2 }}</ng-container>
        </p>
      </div>
      <div class="ginop-checkbox" corporateFormControlErrorContainer>
        <input id="accept-check" type="checkbox" formControlName="accept" [errors]="{ required: 'This is required!' }" />
        <label for="accept-check">
          <span>
            I accept the
            <a *ngIf="participantDocument" [href]="participantDocument.path" target="_blank">privacy statement</a>
            *
            <br />
            <ng-container *ngIf="participantFormCheckboxTitle">{{ participantFormCheckboxTitle }}</ng-container>
          </span>
        </label>
      </div>
      <div class="ginop-form-accept">
        <button class="button button-primary" [appBackgroundColor]="'red'">
          Send
          <ng-container *ngIf="participantFormButton"> / {{ participantFormButton }}</ng-container>
        </button>
      </div>
    </form>
    <div class="thank-you-popup" [class.show]="formSent">
      <div class="popup-background">
        <i class="icon icon-mail-big"></i>
        <div class="thank-you">Thank you for your response! We look forward to seeing you at our event!</div>
      </div>
    </div>
  </div>

  <div *ngIf="pageType === PARTICIPANT && !isParticipantActive" class="container">
    <h2 class="ginop-registration-title">{{ 'label.ginop-participant-registration-closed' | translate }}</h2>
  </div>
</section>
